@let hasContent = hasContent$ | async;

<div
  class="element-wrapper"
  [ngStyle]="wrapperStyles"
  [blazeReferenceDragHitbox]="!collapsed && isInEditor"
  [elementId]="elementId"
  [targetSlotId]="slotId"
>
  <div
    class="header"
    [class.closed]="fullyClosed"
    [class.animating]="isAnimating"
    (click)="toggle()"
  >
    <blaze-element-header
      [color]="props?.style?.header?.title?.color1"
      [fontFamily]="props?.style?.titleBlock?.fontFamily"
      [fontSize]="props?.style?.titleBlock?.fontSize"
      [fontStyle]="props?.style?.titleBlock?.fontStyle"
      [fontWeight]="props?.style?.titleBlock?.fontWeight"
      [horizontalAlign]="props?.content?.header?.align"
      [iconPosition]="props?.content?.header?.iconPosition"
      [iconSize]="props?.style?.titleBlock?.iconSize"
      [iconColor]="props?.content?.header?.iconColor?.color1"
      [icon]="props?.content?.header?.icon"
    >
      {{ title }}
    </blaze-element-header>
    <span class="filler"></span>
    <button
      class="chevron"
      [class.hidden]="!showChevron"
      [class.reverse]="props?.content?.header?.reverseChevron && !collapsed"
    >
      <mat-icon [svgIcon]="chevron" />
    </button>
  </div>
  <div
    #content
    class="content"
    [class.open]="fullyOpen"
    [class.closed]="fullyClosed"
    [@collapsed]="{ value: collapsed }"
    (@collapsed.start)="collapseStart($event)"
    (@collapsed.done)="collapseDone($event)"
  >
    <div class="slot" [class.no-content]="!hasContent">
      <div class="slot-content" [blazeSlotNode]="slots?.slotNodesData?.[slotId]">
        <ng-container *ngTemplateOutlet="slots?.templates?.[slotId] || null" />
      </div>
      @if (isInEditor && hasContent) {
        <div class="hint-drag">
          <span class="description">Drag components here</span>
        </div>
      }
    </div>
  </div>
</div>
